import { render, staticRenderFns } from "./CurrencyInputCom.vue?vue&type=template&id=1a22f61e&"
import script from "./CurrencyInputCom.vue?vue&type=script&lang=js&"
export * from "./CurrencyInputCom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports